module.exports = __webpack_public_path__ + "files/83d7c9d86c7840211931576095d98a2b.png";